import { lazy } from 'react';

export const AffiliateCustomPlansPageLazy = lazy(
    () => import('./affiliate-custom-plans-page'),
);
